import { motion } from "framer-motion";
import { useLanguage } from "../contexts/LanguageContext";

const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/edcc2150-0b82-47f9-839c-552e0da40dc2/images/bef9965a1cad31e7547a1a01a314c298a3c93b1a9e3be31dc6eac17f15f688fa.png";

export default function Hero() {
  const { t } = useLanguage();

  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={HERO_BG} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/70 via-[#050505]/60 to-[#050505]" />
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 pt-32 pb-24">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-3xl"
        >
          <span className="inline-block font-mono text-xs tracking-[0.25em] text-[#00F0FF] mb-6">
            {t("hero.overline")}
          </span>

          <h1 className="font-outfit font-bold text-5xl md:text-6xl lg:text-[72px] leading-none tracking-tighter text-white mb-8">
            {t("hero.title")}
          </h1>

          <p className="text-lg md:text-xl text-neutral-400 font-manrope leading-relaxed mb-12 max-w-2xl">
            {t("hero.subtitle")}
          </p>

          <div className="flex flex-wrap gap-4">
            <a
              data-testid="hero-cta-primary"
              href="/onboarding"
              className="bg-transparent border border-[#00F0FF] text-[#00F0FF] shadow-[0_0_15px_rgba(0,240,255,0.3)] hover:bg-[#00F0FF] hover:text-black hover:shadow-[0_0_25px_rgba(0,240,255,0.5)] transition-all duration-300 rounded-sm px-8 py-3.5 font-medium inline-block"
            >
              {t("hero.cta1")}
            </a>
            <button
              data-testid="hero-cta-cases"
              onClick={() => scrollTo("#cases")}
              className="bg-white/5 border border-white/10 text-white hover:bg-white/10 transition-all duration-300 rounded-sm px-8 py-3.5 font-medium"
            >
              {t("hero.cta2")}
            </button>
            <button
              data-testid="hero-cta-talk"
              onClick={() => scrollTo("#contact")}
              className="text-neutral-400 hover:text-white transition-colors duration-200 px-4 py-3.5 font-medium"
            >
              {t("hero.cta3")} &rarr;
            </button>
          </div>
        </motion.div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00F0FF]/20 to-transparent" />
    </section>
  );
}
